import { AuthScreen } from '../shell/AuthScreen';
import { oauthQueryFromSearch } from '../../lib/oauth-continue';

/**
 * `/sign-in` — the login step of an OAuth authorization, and nothing else.
 *
 * The app's own front door does not live at a path: `RootGate` renders `AuthScreen` in place
 * over whatever the visitor asked for. That works everywhere except here, because Better
 * Auth's provider is configured with `loginPage: '/sign-in'` and REDIRECTS an unauthenticated
 * authorization request to it. Until this route existed that redirect landed on the SPA
 * fallback, the gate drew its usual sign-in form, the signed query was dropped on the floor,
 * and a successful sign-in dumped the owner on their dashboard while the connector that sent
 * them there waited forever. Nothing errored.
 *
 * So this is a thin wrapper on purpose — the same screen, carrying one extra string.
 */
export function SignInPage() {
  const oauthQuery = oauthQueryFromSearch(window.location.search);
  return (
    <AuthScreen
      oauthQuery={oauthQuery}
      onAuthorized={(url) => {
        // Full navigation: the next hop belongs to the authorization server, and the one
        // after that to the connector's own origin. A client-side route push cannot reach
        // either, and would silently strand the flow inside the SPA.
        window.location.assign(url);
      }}
    />
  );
}
